import DATASTORE_TYPES from 'components/shared/datastoreTypes';

const DISK_DATASTORES = [DATASTORE_TYPES.GCP_PD, DATASTORE_TYPES.AWS_EBS];
export default DISK_DATASTORES;
